const qiniu = require("qiniu-js");
import qiniuApi from "@/api/modules/qiniu";
import UUID from "@/utils/uuid";
import { MessageBox } from "element-ui";

export default {
  //上传多文件
  async uploadFiles(files, options = {}) {
    let count = 0;
    let total = files.length;
    let resFiles = [];
    options.bucket = options.bucket || "vybbasevr";
    options.size = options.size ? options.size : 20;

    return new Promise((reslove, reject) => {
      files = Array.from(files);
      let maxOverFiles = files.filter(
        item => item.size > options.size * 1024 * 1024
      );
      if (maxOverFiles.length) {
        let msg = `【${maxOverFiles[0].name}】文件体积超过限制，上限${options.size}M`;
        reject(msg);
        MessageBox.alert(msg, "提示", { type: "error" });
        return;
      }
      files = files.filter(item => item.size <= options.size * 1024 * 1024);
      let queue = files.splice(0, 5);
      doUpload(queue);

      function doUpload(queue) {
        queue.forEach(async file => {
          let key = UUID.generate() + Date.now();
          let persistentOps = null;
          if (options.opt && options.opt.persistentOps) {
            persistentOps =
              options.opt.persistentOps +
              btoa(`${options.bucket}:${key}_thumb`);
          }
          let res = await qiniuApi.getUploadFileToken({
            bucket: options.bucket,
            opt: persistentOps ? { persistentOps } : {}
          });
          let domain = res.data.domain + "/";
          let observable = qiniu.upload(file, key, res.data.token, {
            region: qiniu.region.z0
          });
          observable.subscribe({
            next(res) {
              if (typeof options.onProgress == "function") {
                res.index = file.index;
                options.onProgress(res);
              }
            },
            error(err) {
              reject(err);
            },
            complete(res) {
              count++;
              res.preview = domain + res.key;
              res.name = file.name;
              res.index = file.index;
              resFiles.push(res);
              
              if (files.length) {
                doUpload(files.splice(0, 1));
              }

              if (typeof options.onSuccess == "function") {
                options.onSuccess(res);
              }
              if (typeof options.onComplete == "function" && total == count) {
                options.onComplete(resFiles);
              }
              if (total == count) {
                reslove(resFiles);
              }
            }
          });
        });
      }
    });
  },

  //上传文件
  async uploadFile(file, { progress = () => {} } = {}, bucket = "vybbasevr") {
    let res = await qiniuApi.getUploadFileToken({ bucket, opt: {} });
    return new Promise((reslove, reject) => {
      let key = UUID.generate() + Date.now();
      let domain = res.data.domain + "/";
      let observable = qiniu.upload(file, key, res.data.token, {
        region: qiniu.region.z0
      });
      observable.subscribe({
        next(res) {
          progress(res);
        },
        error(err) {
          reject(err);
        },
        complete(res) {
          reslove({
            preview: domain + res.key,
            name: file.name,
            ...res
          });
        }
      });
    });
  },

  //上传单图
  async uploadImage(file, options = {}) {
    let res = await qiniuApi.getUploadFileToken(options.bucket);
    let token = res.data.token;
    let domain = res.data.protocol + "://" + res.data.domain + "/";
    return new Promise((reslove, reject) => {
      let observable = qiniu.upload(file, UUID.generate() + Date.now(), token, {
        region: qiniu.region.z0
      });
      observable.subscribe({
        error(err) {
          reject(err);
        },
        complete(res) {
          res.preview = domain + res.key;
          res.name = file.name;
          reslove(res);
        }
      });
    });
  }
};
